import { z } from 'zod';
import { DataSourceTablesSchema } from './Common';

export const GoldDataSourceSchema = z
  .object({})
  .merge(DataSourceTablesSchema)
  .superRefine((data, ctx) => {
    data.modifyTables.forEach((table, index) => {
      if (table.embed && table.preserve && !table.embedColumn) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Column name is required',
          path: ['modifyTables', index, 'embedColumn'],
        });
      }

      if (table.embed && table.preserve && !table.embedColumnType) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Column type is required',
          path: ['modifyTables', index, 'embedColumnType'],
        });
      }

      if (!table.sourceTable) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Source table is required',
          path: ['modifyTables', index, 'sourceTable'],
        });
      }
    });

    data.addTables.forEach((table, index) => {
      if (table.embed && table.preserve && !table.embedColumn) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Column name is required',
          path: ['addTables', index, 'embedColumn'],
        });
      }

      if (table.embed && table.preserve && !table.embedColumnType) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Column type is required',
          path: ['addTables', index, 'embedColumnType'],
        });
      }

      if (
        table.tableMode === 'configure' &&
        !table.fields.find((q) => q.name === 'time')
      ) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Table must contain a field named "time"',
          path: ['addTables', index, 'fields'],
        });
      }

      if (!table.sourceTable) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Source table is required',
          path: ['addTables', index, 'sourceTable'],
        });
      }
    });
  });

export type GoldDataSourceSchemaValues = z.infer<typeof GoldDataSourceSchema>;
